// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"351":"1a5a8373b19b195c7216","532":"4fffce1ecfea467ce4da","678":"cb028be64b1aa5674fff"}[chunkId] + ".js";
};